import { data, Form, Outlet, useActionData } from 'react-router'
import { Button } from '#app/components/ui/button.tsx'
import { type Route } from './+types/admin.ts'
import { adminCookie, getAdminToken } from './admin.server.ts'

export async function loader({ request }: Route.LoaderArgs) {
	const password = process.env.ADMIN_SECRET
	if (!password) throw new Error('ADMIN_SECRET is not set')

	const cookieValue = await adminCookie.parse(request.headers.get('Cookie'))
	if (cookieValue === getAdminToken(password)) {
		return { authenticated: true }
	}

	return { authenticated: false }
}

export async function action({ request }: Route.ActionArgs) {
	const password = process.env.ADMIN_SECRET
	if (!password) throw new Error('ADMIN_SECRET is not set')

	const formData = await request.formData()
	const submitted = String(formData.get('password') ?? '')

	if (submitted !== password) {
		return data(
			{ error: 'Invalid password', authenticated: false },
			{ status: 401 },
		)
	}

	return data(
		{ authenticated: true, error: null },
		{
			headers: {
				'Set-Cookie': await adminCookie.serialize(getAdminToken(password)),
			},
		},
	)
}

export default function AdminLayout({ loaderData }: Route.ComponentProps) {
	const actionData = useActionData<typeof action>()

	if (!loaderData.authenticated && !actionData?.authenticated) {
		return (
			<main className="font-poppins flex flex-col items-center px-4 pt-16">
				<div className="bg-muted w-full max-w-sm rounded-xl border border-slate-200 p-8 dark:border-slate-700">
					<h1 className="mb-6 text-2xl font-bold">Admin Access</h1>
					<Form
						method="POST"
						className="flex flex-col gap-4"
						autoComplete="off"
					>
						<div className="flex flex-col gap-1">
							<label htmlFor="password" className="text-sm font-medium">
								Password
							</label>
							<input
								id="password"
								name="password"
								type="password"
								autoFocus
								autoComplete="off"
								className="rounded-md border border-slate-300 px-3 py-2 dark:border-slate-600 dark:bg-slate-800"
							/>
						</div>
						{actionData?.error ? (
							<p className="text-sm text-red-500">{actionData.error}</p>
						) : null}
						<Button type="submit" className="w-full">
							Enter
						</Button>
					</Form>
				</div>
			</main>
		)
	}

	return <Outlet />
}
